import styled from "styled-components/macro";
import { Paper } from "@mui/material";

export const StyledPaper = styled(Paper)`
  box-shadow: 1px 2px 6px 1px rgb(0 0 0 / 25%);
`;
